<div class="container">

  <data-table
  [title]='"Planes"'
  [columns]='columnasPlanes'
  [configuration]='configurationPlanes'
  [reloadTable]='recargarTablaPlanes'
  (delete)='eliminarPlanes($event)'
  (edit)='editarPlan($event)'
  (selection)='seleccionadosPlanes($event)'
  (clickRow)='clickFilaPlan($event)'
  [params]='params'
  [url]='urlGetPlanes'
  (add)='agregarPlan($event)'
  ></data-table>

</div>
